export default {
  "de": {
    "components-form": {
      "Address": "Adresse",
      "Address 2": "Adresse 2",
      "Apt, suite etc. (optional)": "Hausnummer, Wohnungsnummer usw. (optional)",
      "Apt, suite, PO Box, etc. (optional)": "Hausnummer, Wohnungsnummer usw. (optional)",
      "City": "Stadt",
      "Country": "Land",
      "Email address": "E-Mail-Adresse",
      "File too large:": "Datei zu groß:",
      "First Name": "Vorname",
      "Last Name": "Nachname",
      "Phone number": "Telefonnummer",
      "Phone number is required": "Bitte gib deine Telefonnummer ein",
      "Please enter a valid email address.": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      "Please enter a valid phone number": "Falsches Telefonnummer-Format",
      "Please enter a valid Postal Code / Zip.": "Bitte geben Sie ihre Postleitzahl ein.",
      "Please enter your address.": "Bitte Adresse eingeben.",
      "Please enter your city.": "Bitte Ihre Stadt eingeben.",
      "Please enter your email address.": "Bitte gib eine gültige E-Mail-Adresse ein.",
      "Please enter your first name.": "Bitte geben Sie Ihren Vornamen ein.",
      "Please enter your last name.": "Bitte geben Sie Ihren Nachnamen ein.",
      "Please enter your province or state.": "Bitte geben Sie Ihr Bundesland an.",
      "Please select your country.": "Wählen Sie Ihr Land.",
      "Postal Code / Zip": "Postleitzahl",
      "Province / State": "Bundesland",
      "This address is a PO Box": "Diese Adresse ist ein Postfach",
      "Too many files:": "Zu viele Dateien:",
      "Unable to upload file:": "Datei kann nicht hochgeladen werden:",
      "We will only call you if there are questions regarding your order.": "Wir rufen dich nur an, wenn es einmal Rückfragen wegen einer Bestellung gibt."
    }
  },
  "en": {
    "components-form": {
      "Address": "Address",
      "Address 2": "Address 2",
      "Apt, suite etc. (optional)": "Apt, suite etc. (optional)",
      "Apt, suite, PO Box, etc. (optional)": "Apt, suite, PO Box, etc. (optional)",
      "City": "City",
      "Country": "Country",
      "Email address": "",
      "File too large:": "",
      "First Name": "First Name",
      "Last Name": "Last Name",
      "Phone number": "Phone number",
      "Phone number is required": "Phone number is required",
      "Please enter a valid email address.": "",
      "Please enter a valid phone number": "Please enter a valid phone number",
      "Please enter a valid Postal Code / Zip.": "Please enter a valid Postal Code / Zip.",
      "Please enter your address.": "Please enter your address",
      "Please enter your city.": "Please enter your city.",
      "Please enter your email address.": "",
      "Please enter your first name.": "Please enter your first name.",
      "Please enter your last name.": "Please enter your last name.",
      "Please enter your province or state.": "Please enter your province or state.",
      "Please select your country.": "Please select your country.",
      "Postal Code / Zip": "Postal Code / Zip",
      "Province / State": "Province / State",
      "This address is a PO Box": "This address is a PO Box",
      "Too many files:": "",
      "Unable to upload file:": "",
      "We will only call you if there are questions regarding your order.": "We will only call you if there are questions regarding your order."
    }
  },
  "es": {
    "components-form": {
      "Address": "Dirección",
      "Address 2": "Dirección 2",
      "Apt, suite etc. (optional)": "Apto., oficina, etc. (opcional)",
      "Apt, suite, PO Box, etc. (optional)": "Apto., oficina, apartado postal, etc. (opcional)",
      "City": "Ciudad",
      "Country": "País",
      "Email address": "Correo electrónico",
      "File too large:": "Archivo demasiado grande:",
      "First Name": "Nombre",
      "Last Name": "Apellidos",
      "Phone number": "Numero de telefono",
      "Phone number is required": "Se requiere número de teléfono",
      "Please enter a valid email address.": "Introduzca una dirección de correo válida.",
      "Please enter a valid phone number": "Formato incorrecto del número de teléfono",
      "Please enter a valid Postal Code / Zip.": "Introduzca su Código postal/zip.",
      "Please enter your address.": "Introduzca su dirección.",
      "Please enter your city.": "Introduzca su ciudad.",
      "Please enter your email address.": "Introduzca su dirección de correo electrónico",
      "Please enter your first name.": "Por favor, introduzca su Nombre.",
      "Please enter your last name.": "Por favor, introduzca su Apellido.",
      "Please enter your province or state.": "Introduzca su provincia o estado.",
      "Please select your country.": "Seleccione su país.",
      "Postal Code / Zip": "Código postal/zip",
      "Province / State": "Provincia/estado",
      "This address is a PO Box": "Esta dirección es un apartado postal",
      "Too many files:": "demasiados archivos:",
      "Unable to upload file:": "No se ha podido cargar el archivo:",
      "We will only call you if there are questions regarding your order.": "Solo te llamaremos si hay alguna pregunta respecto a tu pedido."
    }
  },
  "fr": {
    "components-form": {
      "Address": "Adresse",
      "Address 2": "Adresse 2",
      "Apt, suite etc. (optional)": "Appt, suite, etc. (facultatif)",
      "Apt, suite, PO Box, etc. (optional)": "Appt, suite, boîte postale, etc. (facultatif)",
      "City": "Ville",
      "Country": "Pays",
      "Email address": "Adresse e-mail",
      "File too large:": "Fichier trop volumineux:",
      "First Name": "Prénom",
      "Last Name": "Nom de famille",
      "Phone number": "Numéro de téléphone durant la journée",
      "Phone number is required": "Veuillez saisir un numéro de téléphone",
      "Please enter a valid email address.": "Veuillez saisir une adresse e-mail valide.",
      "Please enter a valid phone number": "Le format du numéro de téléphone n’est pas correct",
      "Please enter a valid Postal Code / Zip.": "Veuillez saisir votre code postal.",
      "Please enter your address.": "Veuillez saisir votre adresse postale.",
      "Please enter your city.": "Veuillez saisir votre ville.",
      "Please enter your email address.": "Veuillez saisir votre adresse e-mail.",
      "Please enter your first name.": "Merci de saisir votre prénom.",
      "Please enter your last name.": "Merci de saisir votre nom.",
      "Please enter your province or state.": "Veuillez saisir votre province ou état.",
      "Please select your country.": "Veuillez choisir votre pays.",
      "Postal Code / Zip": "Code postal / Zip",
      "Province / State": "Province / État",
      "This address is a PO Box": "Cette adresse est une boîte postale",
      "Too many files:": "Trop de fichiers:",
      "Unable to upload file:": "Impossible de télécharger le fichier:",
      "We will only call you if there are questions regarding your order.": "Nous ne vous contacterons qu’en cas de questions concernant votre commande."
    }
  },
  "it": {
    "components-form": {
      "Address": "",
      "Address 2": "",
      "Apt, suite etc. (optional)": "",
      "Apt, suite, PO Box, etc. (optional)": "",
      "City": "",
      "Country": "",
      "Email address": "",
      "File too large:": "",
      "First Name": "",
      "Last Name": "",
      "Phone number": "",
      "Phone number is required": "",
      "Please enter a valid email address.": "",
      "Please enter a valid phone number": "",
      "Please enter a valid Postal Code / Zip.": "",
      "Please enter your address.": "",
      "Please enter your city.": "",
      "Please enter your email address.": "",
      "Please enter your first name.": "",
      "Please enter your last name.": "",
      "Please enter your province or state.": "",
      "Please select your country.": "",
      "Postal Code / Zip": "",
      "Province / State": "",
      "This address is a PO Box": "",
      "Too many files:": "",
      "Unable to upload file:": "",
      "We will only call you if there are questions regarding your order.": ""
    }
  },
  "jp": {
    "components-form": {
      "Address": "住所",
      "Address 2": "住所 2",
      "Apt, suite etc. (optional)": "建物、部屋番号、郵便番号、など。 (オプション)",
      "Apt, suite, PO Box, etc. (optional)": "建物、部屋番号、郵便番号、など。 (オプション)",
      "City": "都市",
      "Country": "国",
      "Email address": "メールアドレス",
      "File too large:": "ファイルサイズが大きすぎます:",
      "First Name": "名前",
      "Last Name": "名字",
      "Phone number": "電話番号",
      "Phone number is required": "お電話番号は必須です。",
      "Please enter a valid email address.": "有効なメールアドレスを入力してください。",
      "Please enter a valid phone number": "正しくない電話番号形式です",
      "Please enter a valid Postal Code / Zip.": "郵便番号を入力してください。",
      "Please enter your address.": "住所を入力してください。",
      "Please enter your city.": "都市を入力してください。",
      "Please enter your email address.": "メールアドレスを入力してください。",
      "Please enter your first name.": "名前を入力して下さい。",
      "Please enter your last name.": "名字を入力して下さい。",
      "Please enter your province or state.": "都道府県を入力してください。",
      "Please select your country.": "国を選択してください。",
      "Postal Code / Zip": "郵便番号",
      "Province / State": "都道府県",
      "This address is a PO Box": "この住所は私書箱です。",
      "Too many files:": "ファイルが多すぎます:",
      "Unable to upload file:": "ファイルをアップロードできません:",
      "We will only call you if there are questions regarding your order.": "お客様のご注文に関して不明な点がある場合のみ、ご連絡させていただきます。"
    }
  },
  "no": {
    "components-form": {
      "Address": "Adresse",
      "Address 2": "Adresse 2",
      "Apt, suite etc. (optional)": "Leilighet, suite, osv. (valgfritt)",
      "Apt, suite, PO Box, etc. (optional)": "Leilighet, suite, postboks osv. (valgfritt)",
      "City": "By",
      "Country": "Land",
      "Email address": "E-postadresse",
      "File too large:": "Filen er for stor:",
      "First Name": "Fornavn",
      "Last Name": "Etternavn",
      "Phone number": "Telefonnummer pa dagtid",
      "Phone number is required": "Du må oppgi et telefonnummer",
      "Please enter a valid email address.": "Oppgi en gyldig e-postadresse.",
      "Please enter a valid phone number": "Feil telefonnummerformat",
      "Please enter a valid Postal Code / Zip.": "Oppgi postnummeret ditt",
      "Please enter your address.": "Oppgi adressen din.",
      "Please enter your city.": "Oppgi byen din.",
      "Please enter your email address.": "Oppgi e-postadressen din.",
      "Please enter your first name.": "Oppgi fornavnet ditt.",
      "Please enter your last name.": "Oppgi etternavnet ditt.",
      "Please enter your province or state.": "Oppgi din provins eller stat.",
      "Please select your country.": "Velg land.",
      "Postal Code / Zip": "Postnummer",
      "Province / State": "Provins/stat",
      "This address is a PO Box": "Denne adressen er en postboks",
      "Too many files:": "For mange filer:",
      "Unable to upload file:": "Kan ikke laste opp filen:",
      "We will only call you if there are questions regarding your order.": "Vi ringer deg bare dersom det gjelder spørsmål angående bestillingen din."
    }
  },
  "sv": {
    "components-form": {
      "Address": "",
      "Address 2": "",
      "Apt, suite etc. (optional)": "",
      "Apt, suite, PO Box, etc. (optional)": "",
      "City": "",
      "Country": "",
      "Email address": "",
      "File too large:": "",
      "First Name": "",
      "Last Name": "",
      "Phone number": "",
      "Phone number is required": "",
      "Please enter a valid email address.": "",
      "Please enter a valid phone number": "",
      "Please enter a valid Postal Code / Zip.": "",
      "Please enter your address.": "",
      "Please enter your city.": "",
      "Please enter your email address.": "",
      "Please enter your first name.": "",
      "Please enter your last name.": "",
      "Please enter your province or state.": "",
      "Please select your country.": "",
      "Postal Code / Zip": "",
      "Province / State": "",
      "This address is a PO Box": "",
      "Too many files:": "",
      "Unable to upload file:": "",
      "We will only call you if there are questions regarding your order.": ""
    }
  },
  "zh": {
    "components-form": {
      "Address": "地址",
      "Address 2": "地址２",
      "Apt, suite etc. (optional)": "门牌号、邮政信箱等（可选）",
      "Apt, suite, PO Box, etc. (optional)": "门牌号、邮政信箱等（可选）",
      "City": "城市",
      "Country": "国家",
      "Email address": "电子邮箱地址",
      "File too large:": "文件太大:",
      "First Name": "名字",
      "Last Name": "姓氏",
      "Phone number": "电话号码",
      "Phone number is required": "需提供手机号码",
      "Please enter a valid email address.": "请输入有效电子邮件地址。",
      "Please enter a valid phone number": "错误的电话号码格式",
      "Please enter a valid Postal Code / Zip.": "请输入您的邮政编码。",
      "Please enter your address.": "请输入您的地址。",
      "Please enter your city.": "请输入您的城市。",
      "Please enter your email address.": "请输入您的电子邮件地址。",
      "Please enter your first name.": "请输入名字。",
      "Please enter your last name.": "请输入姓氏。",
      "Please enter your province or state.": "请输入您所在省或州",
      "Please select your country.": "请选择您所在国家。",
      "Postal Code / Zip": "邮编/邮政编码",
      "Province / State": "省/州",
      "This address is a PO Box": "地址为邮政信箱",
      "Too many files:": "文件太多：",
      "Unable to upload file:": "无法上传文件:",
      "We will only call you if there are questions regarding your order.": "仅当您的订单存疑时，我们才会给您打电话。"
    }
  }
};
